import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider.js';

export function ProtectedRoute({ children }: PropsWithChildren) {
  const { account, isInitializing } = useAuth();
  if (isInitializing) {
    return null;
  }
  if (account !== null) {
    return children;
  }
  return <Navigate to="/signin" replace />;
}
